import common from './common.json';
import duration from './duration.json';
import home from './home.json';
import navmenu from './navmenu.json';
import settings from './settings.json';
import signIn from './signIn.json';
import stats from './stats.json';
import alerts from './alerts.json';

export default {
  alerts,
  common,
  duration,
  home,
  navmenu,
  settings,
  signIn,
  stats,
};
